import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenceProfile } from "../../../api/LicenceProfile";

interface IBreadCrumbProps {
  licenceProfile: ILicenceProfile;
}

const BreadCrumbs = ({ licenceProfile }: IBreadCrumbProps) => {
  const profileText = `${licenceProfile.organisation} - ${licenceProfile.profileNo}`;
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
          <Breadcrumb.Item
            href={`/licence-profile/${licenceProfile.profileNo}`}
          >
            {profileText}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Compliance</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default BreadCrumbs;
